import { useAppSelector } from '@/shared/hooks';
import { getName } from '@/shared/lib';
import { getImageSrc } from '@/shared/lib';

import { userModel } from '@/entities/user';

import { OrganizationMember } from '../config/types';

export const useDoctorDetails = (userRole: OrganizationMember) => {
  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);
  const doctorFirstName = userRole.PersonalData?.FirstName;
  const doctorLastName = userRole.PersonalData?.LastName;

  const doctorFullName = getName(doctorFirstName, doctorLastName, {
    userLocale,
  });
  const doctorInitials = getName(doctorFirstName, doctorLastName, {
    userLocale,
    shortFirstName: true,
    shortLastName: true,
  });
  const doctorAvatarSrc = getImageSrc(userRole.AvatarAssetID, 'thumbnail');

  return { doctorFullName, doctorInitials, doctorAvatarSrc };
};
